const windowWidth = $(window).width();

function mobileSingleSlider(selector) {
  var sliderInitialized = false;

  function initializeSlider() {
    $(selector).slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 2000
    });

    sliderInitialized = true;
  }

  function destroySlider() {
    $(selector).slick('unslick');
    sliderInitialized = false;
  }

  function handleSlider() {
    if (windowWidth <= 767 && !sliderInitialized) {
      initializeSlider();
    } else if (windowWidth > 767 && sliderInitialized) {
      destroySlider();
    }
  }

  $(window).on('load resize', handleSlider);
}

/*===================================
  Section | Header
===================================*/

// Input Placeholder Text
const values = ['Search by Brand', 'Search by Category', 'What are you looking for?'];
const intervalTime = 5000; 
const typingSpeed = 100;

let currentValueIndex = 0;
let currentCharIndex = 0;
let typingTimeout;
let updatingTimeout;

function typeCharacter() {
  const placeholderInput = document.getElementById('Search-In-Modal-1');
  const currentValue = values[currentValueIndex];
  placeholderInput.placeholder = currentValue.substring(0, currentCharIndex + 1);

  currentCharIndex++;
  if (currentCharIndex < currentValue.length) {
    typingTimeout = setTimeout(typeCharacter, typingSpeed);
  } else {
    updatingTimeout = setTimeout(updatePlaceholderValue, intervalTime - currentValue.length * typingSpeed);
  }
}

function updatePlaceholderValue() {
  const placeholderInput = document.getElementById('Search-In-Modal-1');
  placeholderInput.placeholder = '';

  currentValueIndex = (currentValueIndex + 1) % values.length;
  currentCharIndex = 0;

  typingTimeout = setTimeout(typeCharacter, typingSpeed);
}

updatePlaceholderValue();

// Mobile Menu 
$(document).on('click', '.site-header__top__toggle', function(){
  $(this).toggleClass('icon-menu icon-cross');
  $('.site-header__nav').slideToggle();
})
$('.menu-top-linkdrop-down__menu-toggle').click(function(e){
  // e.preventDefault();
  $(this).find('.nav-mobile-toggle').toggleClass('icon-plus icon-minus');
  $(this).next().slideToggle();
})

/*===================================
  Section | Site Header
===================================*/

// Mobile Slider
mobileSingleSlider('.site_header_slider')

/*===================================
  Section | Hero SliderShow
===================================*/

$("#js-home-slice-0 .promo-unit__slides").slick({
  lazyLoad: false,
  arrows: true,
  prevArrow:'<button class="slick-arrow slick-prev" aria-label="Previous"><span class="ico icon-left"></span></button>',
  nextArrow:'<button class="slick-arrow slick-next" aria-label="Next"><span class="ico icon-right"></span></button>',
  dots: true,
  speed: 620,
  touchThreshold: 200,
  autoplaySpeed: 4000
});

/*===================================
  Section | Featured Categories
===================================*/

mobileSingleSlider('.featured-categories')

/*===================================
  Section | Featured Collection
===================================*/

// Tab
$(".featured-tags__menu__tag").click(function () {
  const __this = $(this);
  const getSelectedHandle = __this.data("tab-handle");
  $(".featured-tags__menu__tag__link").removeClass("featured-tags__menu__tag__link--selected");
  $(".featured-tags__products").hide();
  __this.find(".featured-tags__menu__tag__link").addClass("featured-tags__menu__tag__link--selected");
  $(`.featured-tags__products.${getSelectedHandle}`).css("display", "flex");
});

// Product Hover
$('.featured-tags__products li, .product-list li').each(function(){
    const _this = $(this);
    _this.hover(function(){
       _this.find('div.product').addClass('product--hover') 
    },function(){
      $('.featured-tags__products li div.product, .product-list li div.product').removeClass('product--hover')  
    })
});

const mainSelector = $(".featured-tags__products");
function featuredProductsDestroySlider(mainSelector) {
  mainSelector.each(function () {
    if ($(this).hasClass("slick-initialized")) {
      $(this).slick("unslick");
    }
  });
}

if (windowWidth <= 767) {
  $(".featured-tags__menu").not(".slick-initialized").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:
      '<button class="slick-arrow slick-prev" aria-label="Previous"><span class="ico icon-left"></span></button>',
    nextArrow:
      '<button class="slick-arrow slick-next" aria-label="Next"><span class="ico icon-right"></span></button>',
  });

  $(".featured-tags__products").not(".slick-initialized").first().slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
  });

  $(".featured-tags__menu").on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      const getTabName = $(`.featured-tags__menu__tag[data-slick-index=${currentSlide}]`).attr("data-tab-handle");
      const newSelector = $(`.featured-tags__products.${getTabName}`);
      
      featuredProductsDestroySlider(mainSelector);
      mainSelector.hide();
      newSelector.css("display", "flex");
      newSelector.not(".slick-initialized").slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
      });
    }
  );
} else {
  $(".featured-tags__menu").slick("unslick");
  featuredProductsDestroySlider(mainSelector);
}


/*===================================
  Section | Footer
===================================*/

// Menu Accordion 
if (windowWidth <= 767) {
  const footerLinkSelector = 'site-footer__top__quick-links__title--closed';
  const footerLinkOpenSelector = 'site-footer__top__quick-links__title--open';
  $(`.${footerLinkSelector}`).next().hide();
  $(`.${footerLinkSelector}`).click(function(){
      $(this).toggleClass(`${footerLinkSelector} ${footerLinkOpenSelector}`);
      $(this).next().slideToggle();
  })
}

/*===================================
  Page | Product
===================================*/

$('.product__image__main').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: '.product__image__thumbs',
  prevArrow: '<button class="slide-arrow prev-arrow"><span class="ico icon-left"></span></button>',
  nextArrow: '<button class="slick-arrow slick-next"><span class="ico icon-right"></span></button>'
});

$('.product__image__thumbs').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.product__image__main',
  dots: false,
  centerMode: true,
  focusOnSelect: true,
   prevArrow: '<button class="slide-arrow prev-arrow"><span class="ico icon-left"></span></button>',
    nextArrow: '<button class="slick-arrow slick-next"><span class="ico icon-right"></span></button>'
});

// Product tab
$(".product .product-tabs__list__item__link").click(function (e) {
  e.preventDefault();
  const $this = $(this);
  const id = $this.attr("href");
  const $tabItem = $this.closest(".product-tabs__list__item");
  const $tabContent = $(id);
  const isTabActive = $tabItem.hasClass("active");
  
  $(".product .product-tabs__list__item").removeClass("active");
  $(".product .product-tabs__content1").hide().removeClass("active");

  if (!isTabActive) {
    $tabItem.addClass("active");
    $tabContent.show().addClass("active");
  }
});

$('#select_o_80844').change(function() {
  $('.mw-option--type-swatch').addClass('mw-hidden');
  $('#'+this.value).removeClass('mw-hidden')
});
/*===================================
  Page | Swatch request
===================================*/

$(document).on("click", ".swatch-request__attributegroup", function() {
  $(this).toggleClass('active_filter')
  if($('.active_filter').length > 0){
    $('.swatch-request__swatch_groups').addClass('hidden').removeClass('visible')
  }else{
    $('.swatch-request__swatch_groups').removeClass('hidden');
  }
  $('.active_filter').each(function(){
    var data_id = $(this).data('id');
    $('.swatch-request__swatch_groups[data-id="'+data_id+'"]').addClass('visible').removeClass('hidden')
  })
})

$(document).on("click", "#swatch_tag_filter .filter_swatch", function() {
  $(this).toggleClass('active_filter')
  if($('#swatch_tag_filter .filter_swatch.active_filter').length > 0){
    $('.swatch_attributes .swatch-request__swatch').addClass('hidden').removeClass('visible')
  }else{
    $('.swatch_attributes .swatch-request__swatch').removeClass('hidden');
  }
  $('#swatch_tag_filter .active_filter').each(function(){
    var data_color = $(this).attr('title');
      $('.swatch_attributes .swatch-request__swatch').addClass('hidden').removeClass('visible')
      $('.swatch_attributes .swatch-request__swatch').each(function(){
          var data_color1 = $(this).data('color');
          if(data_color1.indexOf(data_color) > -1){
              $(this).addClass('visible').removeClass('hidden')
          }
      });
    })
})
$(document).on("click", ".swatch_attributes .swatch-request__swatch", function() {
  if($(".swatch_attributes .swatch-request__swatch.selected").length < 6){
  if($(this).hasClass('selected') == true){
    console.log('dataa-id', $(this).data('id'));
    $(this).removeClass('selected')
    $(this).find('.icon-cross').hide()
    $('#'+$(this).data('id')).parent('.swatch-request__selection-swatch').html('<div> <span class="ico icon-question"></span> </div>').removeClass('chosen').addClass('placeholder');
  }else{
    $(this).addClass('selected');
   $('.swatch-request__selection-swatch').html('<div> <span class="ico icon-question"></span> </div>').removeClass('chosen').addClass('placeholder');
      $(".swatch_attributes .swatch-request__swatch.selected").each(function(index){
        var src = $(this).find('.swatch_attribute_large').attr('src');
        var title = $(this).find('.title').text();
        var id = $(this).data('id');
        var child = index + 1;
        console.log('title',title,child)
        $('.swatch-request__selection-swatch.placeholder:nth-child('+child+')').html('<div id="'+id+'" class="selcted_class">  <input type="checkbox" name="contact[Order Free Fabric Samples '+ child +']" checked style="display:none" value="'+ title +'"><img alt="Arran Natural" src="'+src+'" class=" lazyloaded">'+title+'<span class="ico icon-close"></span> </div>')
        $('.swatch-request__selection-swatch:nth-child('+child+')').removeClass('placeholder').addClass('chosen');
      })
  }
    $('#max_selected_reached').hide();
    }else{
    $('#max_selected_reached').show();
    }
})
$(document).on("click", '.swatch-request__selection-swatch.chosen', function() {
  if($(".swatch_attributes .swatch-request__swatch.selected").length <= 6){
    $('#max_selected_reached').hide();
  }else{
    $('#max_selected_reached').show();
  }
  $(this).removeClass('chosen').addClass('placeholder');
   var data_id = $(this).find('.selcted_class').attr('id');
  $('.swatch_attributes .swatch-request__swatch[data-id='+ data_id +']').removeClass('selected');
  $(this).html('<div> <span class="ico icon-question"></span> </div>')
});
 $(".swatch_attributes .swatch-request__swatch.visible.selected").each(function(){
$(this).hover(function(){
    if($(this).hasClass('selected') == true)   $(this).find('.icon-cross').show()
    }, function(){
     if($(this).hasClass('selected') == true)$(this).find('.icon-cross').hide()
  });  
 });

/*===================================
  Page | Collections
===================================*/

// Product Grid or List
$(document).ready(function() {
    var $searchResultsProducts = $('.search-results-products');
    var $productList = $('ul.search-results-products__list');
    var $productListItems = $productList.find('li');
    
    var preferredView = localStorage.getItem('preferredView');
    if (preferredView === 'list') {
        $searchResultsProducts.removeClass().addClass('search-results-list');
        $productList.attr('id', 'js-search-results-products__list');
        $productListItems.each(function() {
            $(this).removeClass().addClass('col l-col-32 m-col-32 s-col-32');
        });
    }
    
    $('.view-type-btn .grid_view_btn').click(function(e) {
        e.preventDefault();
        
        var isGridView = $(this).hasClass('grid_view_on');
        var viewClass = isGridView ? 'search-results-grid' : 'search-results-list';
        var itemClass = isGridView ? 'col l-col-8 m-col-third s-col-16' : 'col l-col-32 m-col-32 s-col-32';
        var productListId = isGridView ? 'product-grid' : 'js-search-results-products__list';
        
        $searchResultsProducts.removeClass().addClass(viewClass);
        $productList.attr('id', productListId);
        
        $productListItems.each(function() {
            $(this).removeClass().addClass(itemClass);
        });
        
        localStorage.setItem('preferredView', isGridView ? 'grid' : 'list');
    });
});



/*===================================
  Page | Blog
===================================*/

// SiderBar
if (windowWidth <= 767) {
  $(".sidebar").hide();
  $(".sidebar-toggle").click(function () {
    $(".sidebar").slideToggle("slow");
    $(this).children(".ico").toggleClass("icon-plus").toggleClass("icon-minus");
  });
  $(".widget__title").click(function (e) {
    e.preventDefault();
    var $this = $(this),
      active = $this.hasClass("widget__title--active");
    $this
      .toggleClass("widget__title--active", !active)
      .parent()
      .siblings("ul,div,form")
      [!active ? "show" : "hide"]();
  });
}

/*===================================
  Section | Accordion
===================================*/
$('main:not(.product) .product-tabs__list__item').click(function(){
  $(this).toggleClass('active');
  $(this).parents('.product-tabs').next().slideToggle();
})

/*===================================
  Page | Register
===================================*/
$('.loqate-address-options.direct').click(function(){
  $(this).hide();
  $('.loqate-address-lines').show();
})
$('.zoom').zoom();			 
$(document).ready(function(){
    //FANCYBOX
    //https://github.com/fancyapps/fancyBox
    $(".fancybox").fancybox({
        openEffect: "none",
        closeEffect: "none"
    });
});

// Change Item On Cart
$(document).on('click','.quantity-selector__button',function(){
  var input = $(this).parents('.quantity-selector').find('.quantity-selector__value');
  var qty = parseInt(input.val());
  var lineID = $(this).attr('data-line-id');
console.log(qty,'qtyqtyqty')
  if ($(this).attr('data-action') == 'increase-quantity') {
      qty += 1;
  } else {
      qty = Math.max(0, qty - 1);
  }
  console.log(qty,'qty',input,'input',lineID,'lineID')
  input.val(qty);
  changeQty(qty, lineID);
});
// $('.checkout-button--remove').on('click',function(){
//   var lineID = $(this).closest('.basket-list__item').data('basket_key');
//   changeQty(0, lineID);
// })
function changeQty(quantity, lineID) {
  var data = { quantity: quantity, id: lineID };
  $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      success: function (cart) {
        location.href = '/cart';
      }
  });
}
$(document).on('click','.cart-recap__note-button',function(){
  $(this).next().slideToggle();
})

$(document).on('click','.form__submit--tight',function(){
  $(this).parents('#order-note').slideToggle()
})

$(document).ready(function() {
  $("#js-site-header__sticky .site-header__sticky__close").click(function() {
    $("#js-site-header__sticky").hide();
  });
});